// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-dashed[data-v-10582694]{border:2px dashed #dee2e6!important}.btn-xs[data-v-10582694]{padding:.15rem .4rem;font-size:.75rem;line-height:1.2}", ""]);
// Exports
module.exports = exports;
